import { Building, FileText, Calculator, Key, Users, CalendarDays, Palette, DollarSign } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const PropertyManagementIndustry = () => (
  <IndustryPlaceholderPage
    name="Property Management Services"
    icon={Building}
    iconColor="text-primary"
    iconBg="bg-[hsl(var(--primary)/0.1)]"
    headline="Property Management Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps property management companies create professional service proposals, management agreements, and vendor contracts — all from one platform."
    valueProps={[
      { title: "Win More Properties", description: "Build polished management proposals with fee structures, service scopes, and financial projections that impress property owners." },
      { title: "Simplify Onboarding", description: "Generate comprehensive management agreements with maintenance plans, tenant policies, and vendor coordination in minutes." },
      { title: "Built for Property Managers", description: "Templates for residential, commercial, HOA, and multi-family management — designed by industry professionals." },
    ]}
    features={[
      { icon: Calculator, label: "Fee Calculators" },
      { icon: CalendarDays, label: "Lease Scheduling" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Key, label: "Tenant Management" },
      { icon: Building, label: "Portfolio Templates" },
      { icon: Users, label: "Vendor Coordination" },
      { icon: Palette, label: "Custom Branding" },
      { icon: DollarSign, label: "Financial Projections" },
    ]}
    benefits={[
      "Create property-specific proposals with management fees, service tiers, and maintenance plans",
      "Auto-calculate management fees based on unit count, property value, and service level",
      "Generate branded proposals with property photos and financial summaries",
      "Send management agreements with digital signatures for fast owner approval",
      "Track portfolio-wide contracts, vendor agreements, and renewal dates",
      "Support residential, commercial, and mixed-use property types",
    ]}
    proposalTemplates={[
      "Residential Property Management",
      "Commercial Property Management",
      "HOA & Community Management",
      "Multi-Family Portfolio Management",
      "Vacation & Short-Term Rental Management",
    ]}
    contractTemplates={[
      "Property Management Agreement",
      "HOA Management Contract",
      "Vendor Service Agreement",
      "Lease Administration Contract",
    ]}
    faq={[
      { q: "What is Sentinel Forge for property management?", a: "Sentinel Forge is a proposal and contract platform for property management companies. It helps you build management proposals, define fee structures, and send digital agreements to property owners." },
      { q: "Can I create proposals for different property types?", a: "Yes. Templates cover residential, commercial, HOA, multi-family, and short-term rental management with property-specific scoping." },
      { q: "How does fee calculation work?", a: "You define property details, unit counts, service tier, and scope. The system calculates monthly and annual management fees including maintenance reserves." },
      { q: "Can I manage a portfolio of properties?", a: "Yes. You can create proposals and contracts for individual properties or entire portfolios under a single management agreement." },
      { q: "Do property owners need an account to sign?", a: "No. Owners receive a secure link to review and digitally sign management agreements without creating an account." },
      { q: "Can I add my company's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will property management be available?", a: "We're building it now. Join the waitlist to get notified when the property management module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to scale your property management company?"
    ctaDescription="Join property managers preparing to automate proposals and owner agreements with Sentinel Forge."
  />
);

export default PropertyManagementIndustry;
